const NotFoundPage = () => {
  return <div>404 - Nothing to see!</div>;
};

export default NotFoundPage;
